import { useEffect, useRef } from 'react';

export function useEndOfList(onReach: () => void, watchKey: unknown) {
  const endRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const end = endRef.current;
    if (!end || typeof IntersectionObserver === 'undefined') return undefined;

    const observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) onReach();
    });
    observer.observe(end);

    return () => observer.disconnect();
  }, [onReach, watchKey]);

  return endRef;
}
